export const ENVIRONMENT_GLOBAL = {
  languages: ['es', 'en'],
  idleConfig: {
    innactivityTime: 1200,
    timerAnswer: 30,
  },
};
